import styled from 'styled-components';
import { GlobalToken } from 'antd';

import EPInput from '@/comp/EPInput';
import { getTableCss } from '@/comp/pages/EnginePage/Engine/Common/styled';

const getCommonCss = token => `
  ${getTableCss(token)}

  height: 100%;

  .top-section {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .upper-bound {
    display: flex;
    align-items: center;
  }

  .input-flex-row {
    display: flex;
    flex-grow: 1;
    align-items: baseline;
  }

  .value-unit {
    display: flex;
    align-items: baseline;
  }

  .edited {
    background-color: ${token.colorBorderSecondary};
    border-radius: 2px;
  }

  .input-unit {
    color: ${token.colorTextSecondary};
    font-size: ${token.fontSizeSM}px;
    margin-right: ${token.marginXXS}px;
  }

  .header-cell {
    margin-left: ${token.marginXXS}px;
  }

  .sensors-configuration {
    display: flex;
    flex-direction: column;
    bottom: 0;
    color: ${token.colorText};

    .sensor-priority {
      display: flex;
      font-size: ${token.fontSizeSM}px;
      
      .priority {
        font-weight: ${token.fontWeightStrong};
      }
    }
  }

  .editable {
    color: ${token.colorPrimary};
  }

  .range-name {
    color: ${token.colorPrimary};
    font-size: ${token.fontSize}px;
      }

  .read-only {
    color: ${token.colorTextSecondary};
  }
`;

interface LevelsContainerProps {
  $hasFinishedWizard: boolean;
  $isReadOnly: boolean;
  theme: {
    token: GlobalToken;
  };
}

export const FlowLevelsContainer = styled.div<LevelsContainerProps>`
  display: flex;
  flex-direction: column;
  padding-left: ${({ theme: { token } }) => token.paddingXL}px;
  max-height: ${({ $hasFinishedWizard }) => ($hasFinishedWizard ? '509px' : '426px')};
  ${({ $isReadOnly }) => $isReadOnly && 'pointer-events: none;'}

  .add-level-button {
    align-self: flex-end;
  }

  .units-dropdown {
    display: flex;
    align-items: center;
    margin-bottom: ${({ theme: { token } }) => token.marginXXL}px;
    width: fit-content;

    .units-label {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      color: ${({ theme: { token } }) => token.colorTextTertiary};
      margin-right: ${({ theme: { token } }) => token.marginXS}px;
    }
  }

  ${({ theme: { token } }) => getCommonCss(token)}
`;

interface InputProps {
  value: string | number;
  $shouldUnderline?: boolean;
  $hasBeenEdited?: boolean;
  $valueLength?: number;
  $isEditable?: boolean;
  theme: {
    token: GlobalToken;
  };
}

export const Input = styled(EPInput)<InputProps>`
  &.ant-input {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
        padding-left: 0;
    padding-right: 0;
    height: 21px;
    color: ${({ $isEditable, theme: { token } }) => ($isEditable ? token.colorPrimary : token.colorTextSecondary)};
    width: ${({ value, $valueLength, $hasBeenEdited }) =>
      $valueLength
        ? `calc(${value === Infinity ? $valueLength - 3 : $valueLength}ch + 2ch);`
        : $hasBeenEdited
        ? '80px;'
        : 'fit-content'}
    max-width: 150px;
    border: none;
    border-radius: 2px;
    background-color: ${({ $hasBeenEdited, theme: { token } }) =>
      $hasBeenEdited ? token.colorBorderSecondary : token.colorBgContainer};
    ${({ $valueLength }) => ($valueLength ? 'text-align: center;' : null)}

    &.ant-input-disabled {
      opacity: 1;
      color: ${({ theme: { token } }) => token.colorTextSecondary};

      &[disabled] {
        &:hover {
          cursor: default;
          border: none;
        }
      }
    }

    &::placeholder {
      color: ${({ theme: { token } }) => token.colorBorder};
      ${({ $shouldUnderline }) => $shouldUnderline && 'text-decoration: underline;'}
      padding-left: ${({ theme: { token } }) => token.paddingXXS}px;
    }

    &:first-child {
      margin-top: 0;
    }
  }
`;

export const PressureLevelsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${({ theme: { token } }) => token.paddingXL}px;
  height: 100%;
  max-height: ${({ $hasFinishedWizard }: { $hasFinishedWizard: boolean }) => ($hasFinishedWizard ? '509px' : '426px')};

  .add-pressure-range-button {
    align-self: flex-end;
  }

  .id {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 50px;
  }

  ${({ theme: { token } }) => getCommonCss(token)}

  .table-container {
    display: flex;
    flex-direction: column;
  }

  .disabled {
    pointer-events: none;
  }
`;

interface ResultContainerProps {
  $hasFinishedWizard: boolean;
  theme: {
    token: GlobalToken;
  };
}

export const ResultContainer = styled.div<ResultContainerProps>`
  display: flex;
  flex-direction: column;
  padding-left: ${({ theme: { token } }) => token.paddingXL}px;
  // max-height: ${({ $hasFinishedWizard }) => ($hasFinishedWizard ? '509px' : '426px')};
  ${({ $hasFinishedWizard }) => !$hasFinishedWizard && 'max-height: 426px;'}
  overflow: scroll;

  .flow-range {
    color: ${({ theme: { token } }) => token.colorText};
  }

  ${({ theme: { token } }) => getCommonCss(token)}
`;
